<template>
  <b-container fluid class="padding-none">
    <!-- <p>hello</p> -->
    <ui-header :backButton="true" />
    <div class="container-fluid pt-2 px-4">
      <div
        class="position-relative w-100 overflow-hidden"
        style="padding-top: 56.25%;"
      >
        <iframe
          style="top: 0px"
          class="border-0 w-100 top-0 h-100 position-absolute"
          src="https://player.vimeo.com/video/544483447?color=44619b&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;speed=1"
        ></iframe>
      </div>
      <b-row class="justify-content-center mt-2 padding-none">
        <b-col class="col-md-3 col pr-1 ">
          <b-button
            @click="$router.push({ name: 'login-app' })"
            class="border-black border-bold font-weight-bold w-100  bg-white text-black mr-2 shadow-none"
          >
            {{ $t("login") }}
          </b-button>
        </b-col>
        <b-col class="col-md-3 col pl-1">
          <b-button
            @click="$router.push({ name: 'login-try-now' })"
            class="bg-black w-100 text-white border border-black shadow-none"
          >
            {{ $t("login-try-it-now") }}
          </b-button>
        </b-col>
      </b-row>
      <bottom-policies :onlyLogo="true" />
    </div>
  </b-container>
</template>
<script>
import UiHeader from "../../components/ui/app-header";
import BottomPolicies from "../../components/ui/bottom-policies";
export default {
  name: "login-video",
  components: {
    UiHeader,
    BottomPolicies
  },
  created() {
    this.$gtag.event("how_it_works_video", { method: "Google" });
  },
  Data() {
    return {
      mainVimeoSrc:
        "https://player.vimeo.com/video/544483447?color=44619b&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;speed=1"
    };
  }
};
</script>
